export const update = {
  form: {
    code: '担当者 ID',
    name: ' 担当者名',
    update: '保存',
    requireCode: 'オペレーターコードを入力してください',
    requireName: 'オペレーター名を入力してください',
  },
  pageHeader: {
    title: '担当者情報編集',
    back: '戻る',
  },
}
